import { Routes } from '@angular/router';
import { Login } from './components/login/login';
import { FileNoticed } from './components/file-noticed/file-noticed';
import { Complete } from './components/complete/complete';





export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: Login },
  { path: 'file-noticed', component: FileNoticed },
  { path: 'complete', component: Complete },

  // { path: '**', redirectTo: 'login' },

];
